import faviconDefaultPng from "images/favicon.png";
import faviconDefaultIco from "images/favicon.ico";
import faviconOrlPng from "images/favicon_orl.png";
import faviconOrlIco from "images/favicon_orl.ico";
import faviconOlEbcPng from "images/favicon_ohiolink.png";
import faviconOlEbcIco from "images/favicon_ohiolink.ico";
import faviconOlEbcPng2 from "images/favicon_ohiolink_2.png";
import faviconOlEbcIco2 from "images/favicon_ohiolink_2.ico";
import faviconOlEbcPng3 from "images/favicon_ohiolink_3.png";
import faviconOlEbcIco3 from "images/favicon_ohiolink_3.ico";
import mainMenuLogoBiblioboard from "images/logo-bb.png";
import mainMenuLogoOrl from "images/logo-orl.png";
import mainMenuLogoOlEbc from "images/logo-ol-ebc-main.png";
import footerLogoBiblioboard from "images/logo-bb-horo.png";
import footerLogoOlEbc from "images/logo-ol-ebc-footer.png";
import footerLogoOlEbc2 from "images/logo-ol-ebc-footer-2.png";
import mainMenuLogoTarget from "images/logo-target-main.png";
import footerLogoTarget from "images/logo-target-footer.png";
// PALACE
import mainMenuLogoTpp from "images/logo-tpp.png";
import faviconPalaceIco from "images/favicon_palace.ico";
import faviconPalacePng from "images/favicon_palace.png";
import logoPalace from "images/logo-palace.png";
import logoPalaceBookshelf from "images/logo-palace-bookshelf.png";

export const FAVICON_OPTIONS = {
  ORL: {
    ico: faviconOrlIco,
    png: faviconOrlPng,
  },
  OL: {
    ico: faviconOlEbcIco,
    png: faviconOlEbcPng,
  },
  OL2: {
    ico: faviconOlEbcIco2,
    png: faviconOlEbcPng2,
  },
  OL3: {
    ico: faviconOlEbcIco3,
    png: faviconOlEbcPng3,
  },
  PALACE: {
    ico: faviconPalaceIco,
    png: faviconPalacePng,
  },
  DEFAULT: {
    ico: faviconDefaultIco,
    png: faviconDefaultPng,
  },
};

export const MAIN_MENU_LOGO_OPTIONS = {
  DEFAULT: mainMenuLogoBiblioboard,
  OL: mainMenuLogoOlEbc,
  OL2: footerLogoOlEbc2,
  ORL: mainMenuLogoOrl,
  TARGET: mainMenuLogoTarget,
  PALACE: logoPalace,
  TPP: mainMenuLogoTpp,
};

export const FOOTER_LOGO_OPTIONS = {
  DEFAULT: footerLogoBiblioboard,
  OL: footerLogoOlEbc,
  OL2: footerLogoOlEbc2,
  ORL: mainMenuLogoOrl,
  PB: logoPalaceBookshelf,
  TARGET: footerLogoTarget,
  TPP: mainMenuLogoTpp,
};

export const getFaviconOption = faviconOptionName =>
  FAVICON_OPTIONS[faviconOptionName] ? FAVICON_OPTIONS[faviconOptionName] : FAVICON_OPTIONS.DEFAULT;

export const getMainMenuLogoOption = logoOptionName =>
  MAIN_MENU_LOGO_OPTIONS[logoOptionName] ? MAIN_MENU_LOGO_OPTIONS[logoOptionName] : MAIN_MENU_LOGO_OPTIONS.DEFAULT;

export const getFooterLogoOption = logoOptionName =>
  FOOTER_LOGO_OPTIONS[logoOptionName] ? FOOTER_LOGO_OPTIONS[logoOptionName] : FOOTER_LOGO_OPTIONS.DEFAULT;
